
import {defineComponent, PropType} from "vue"
import Slider from '@vueform/slider'
import '@vueform/slider/themes/default.css'
import NumberFilter from "@/services/filters/types/NumberFilter";

export default defineComponent({
  components: {
      Slider
  },
  props: {
    filter: {
      required: true,
      type: Object as PropType<NumberFilter>
    }
  },
  methods: {
    onSliderChanged(){
      this.filter.setValues(this.values[0],this.values[1]);
    }
  },
  data(){
    return {
      values: [0,0] as number[],
    }
  },
  mounted() {
    this.values = this.filter.values;
  }
})
